const autoNgTemplateLoaderTemplate1 = require('./registries.html');

angular.module('portainer.app').component('endpointRegistriesView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'EndpointRegistriesController',
  bindings: {
    endpoint: '<',
  },
});
